import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { Notify } from '@flexisaf/flexibull2';
import urls from 'utils/config';
import {
  sendEmailToApplicantsFailed,
  sendEmailToApplicantsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* sendEmail({ payload: { data, cb } }) {
  const { candidateIds, message, subject, applicationId, stage } = data;
  const url = `${API_BASE_URL}/email/candidates`;

  const submissionData = {
    message,
    subject,
    applicationId,
    stageId: stage,
  }

  if (candidateIds.length > 0) {
    Object.assign(submissionData, {
      candidateIds,
    })
  }

  const response = yield request({
    method: 'post',
    data: submissionData,
    url,
  });
  if (response.success) {
    Notify('Email sent successfully', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
    yield put(sendEmailToApplicantsSuccess()); 
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(sendEmailToApplicantsFailed(response.message));
  }
}

export function* onEmailSend() {
  yield takeEvery(
    ApplicantsActionTypes.SEND_EMAIL_START,
    sendEmail
  );
}
